import * as React from 'react';
import { NotificationContext } from '@/contexts/notifications/notification-provider';

export function useNotifications() {
  const context = React.useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
}
